import { render, staticRenderFns } from "./CourseNameForm.vue?vue&type=template&id=d6466260&"
import script from "./CourseNameForm.vue?vue&type=script&lang=ts&"
export * from "./CourseNameForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports